import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Grid as MuiGrid, List as MuiList, ListItem as MuiListItem, ListItemText as MuiListItemText, makeStyles } from '@material-ui/core';
import Button from '../Button';
import { designTokens } from '../Theme.design-tokens';
var useStyles = makeStyles(function () {
  return {
    root: {
      margin: 'auto'
    },
    list: {
      width: 200,
      height: 200,
      overflow: 'auto'
    },
    selected: {
      backgroundColor: designTokens.colors.blue500
    }
  };
});

function not(a, b, idProp) {
  return a.filter(function (itemA) {
    return !b.find(function (itemB) {
      return itemA[idProp] === itemB[idProp];
    });
  });
}

function intersection(a, b, idProp) {
  return a.filter(function (itemA) {
    return b.find(function (itemB) {
      return itemA[idProp] === itemB[idProp];
    });
  });
}

var TransferList = function TransferList(_ref) {
  var origin = _ref.origin,
      selected = _ref.selected,
      idProp = _ref.idProp,
      labelProp = _ref.labelProp,
      e2e = _ref.e2e,
      dsOnChange = _ref.dsOnChange;
  var classes = useStyles();

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      checked = _React$useState2[0],
      setChecked = _React$useState2[1];

  var _React$useState3 = React.useState(not(origin, selected, idProp)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      left = _React$useState4[0],
      setLeft = _React$useState4[1];

  var _React$useState5 = React.useState(selected),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      right = _React$useState6[0],
      setRight = _React$useState6[1];

  var leftChecked = intersection(checked, left, idProp);
  var rightChecked = intersection(checked, right, idProp);

  var handleToggle = function handleToggle(item) {
    return function () {
      var currentIndex = checked.indexOf(item);

      var newChecked = _toConsumableArray(checked);

      if (currentIndex === -1) {
        newChecked.push(item);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setChecked(newChecked);
    };
  };

  var handleCheckedRight = function handleCheckedRight() {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked, idProp));
    setChecked(not(checked, leftChecked, idProp));
    dsOnChange === null || dsOnChange === void 0 ? void 0 : dsOnChange({
      selected: right.concat(leftChecked)
    });
  };

  var handleCheckedLeft = function handleCheckedLeft() {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked, idProp));
    setChecked(not(checked, rightChecked, idProp));
    dsOnChange === null || dsOnChange === void 0 ? void 0 : dsOnChange({
      selected: not(right, rightChecked, idProp)
    });
  };

  var handleAllLeft = function handleAllLeft() {
    setLeft(left.concat(right));
    setRight([]);
    dsOnChange === null || dsOnChange === void 0 ? void 0 : dsOnChange({
      selected: []
    });
  };

  var itemList = function itemList(items) {
    return /*#__PURE__*/React.createElement(MuiList, {
      dense: true,
      component: "div",
      role: "list",
      className: classes.list
    }, items.map(function (item) {
      return /*#__PURE__*/React.createElement(MuiListItem, {
        key: item[idProp],
        role: "listitem",
        button: true,
        onClick: handleToggle(item),
        selected: checked.indexOf(item) > -1,
        classes: {
          selected: classes.selected
        }
      }, /*#__PURE__*/React.createElement(MuiListItemText, {
        id: item[idProp],
        primary: item[labelProp]
      }));
    }), /*#__PURE__*/React.createElement(MuiListItem, null));
  };

  return /*#__PURE__*/React.createElement(MuiGrid, _extends({
    container: true,
    spacing: 2,
    alignItems: "center",
    className: classes.root
  }, e2e && {
    'data-e2e': e2e
  }), /*#__PURE__*/React.createElement(MuiGrid, {
    item: true,
    xs: 5
  }, itemList(left)), /*#__PURE__*/React.createElement(MuiGrid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(MuiGrid, {
    container: true,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    dsOnClick: handleCheckedRight,
    disabled: leftChecked.length === 0,
    icon: "arrow_forward",
    a11yLabel: "Move right",
    tooltip: "Move right"
  }, e2e && {
    e2e: "".concat(e2e, "-move-right")
  })), /*#__PURE__*/React.createElement(Button, _extends({
    dsOnClick: handleCheckedLeft,
    disabled: rightChecked.length === 0,
    icon: "arrow_back",
    a11yLabel: "Move left",
    tooltip: "Move left"
  }, e2e && {
    e2e: "".concat(e2e, "-move-left")
  })), /*#__PURE__*/React.createElement(Button, _extends({
    dsOnClick: handleAllLeft,
    disabled: right.length === 0,
    icon: "highlight_remove",
    a11yLabel: "Move all left",
    tooltip: "Move all left"
  }, e2e && {
    e2e: "".concat(e2e, "-move-all-left")
  })))), /*#__PURE__*/React.createElement(MuiGrid, {
    item: true,
    xs: 5
  }, itemList(right)));
};

export default TransferList;

try {
  TransferList.__docgenInfo = {
    description: '',
    displayName: 'TransferList',
    methods: [],
    props: {
      origin: {
        defaultValue: null,
        description: '',
        name: 'origin',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      selected: {
        defaultValue: null,
        description: '',
        name: 'selected',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      idProp: {
        defaultValue: null,
        description: '',
        name: 'idProp',
        required: true,
        type: {
          name: 'string'
        }
      },
      labelProp: {
        defaultValue: null,
        description: '',
        name: 'labelProp',
        required: true,
        type: {
          name: 'string'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(args: { selected: any[]; }) => void'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map